(function () {

  function launchIndependenceBurst() {

    if (document.getElementById('bie-burst')) return;

    var container = document.createElement('div');

    container.id = 'bie-burst';

    document.body.appendChild(container);


    /* ==============================
       STYLES
    ============================== */

    var style = document.createElement('style');

    style.innerHTML = `

      #bie-burst {
        position: fixed;
        inset: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 2147483647;
        overflow: hidden;
      }


      /* MAIN PARTICLES */

      .bie-particle {
        position: absolute;

        width: 7px;
        height: 14px;

        border-radius: 2px;

        opacity: 0;

        animation:
          bieBurst
          2.2s
          cubic-bezier(.15,.65,.25,1)
          forwards;
      }


      @keyframes bieBurst {

        0% {

          opacity: 0;

          transform:
            translate(-50%, -50%)
            scale(.25)
            rotate(0deg);

        }


        10% {

          opacity: 1;

        }


        45% {

          opacity: 1;

        }


        65% {

          opacity: 1;

        }


        82% {

          opacity: .8;

        }


        100% {

          opacity: 0;

          transform:
            translate(
              calc(-50% + var(--x)),
              calc(-50% + var(--y))
            )
            scale(.7)
            rotate(var(--rotation));

        }

      }


      /* CENTRAL FLASH */

      .bie-flash {

        position: absolute;

        left: 50%;
        top: 42%;

        width: 55px;
        height: 55px;

        border-radius: 50%;

        background:
          rgba(255,255,255,.85);

        transform:
          translate(-50%, -50%)
          scale(0);

        animation:
          bieFlash
          .7s
          ease-out
          forwards;

      }


      @keyframes bieFlash {

        0% {

          opacity: .8;

          transform:
            translate(-50%, -50%)
            scale(0);

        }


        45% {

          opacity: .35;

          transform:
            translate(-50%, -50%)
            scale(2);

        }


        100% {

          opacity: 0;

          transform:
            translate(-50%, -50%)
            scale(4);

        }

      }


      /* SMALL GLOW */

      .bie-glow {

        position: absolute;

        left: 50%;
        top: 42%;

        width: 18px;
        height: 18px;

        border-radius: 50%;

        background:
          rgba(255,255,255,.9);

        box-shadow:
          0 0 20px rgba(255,153,51,.5),
          0 0 35px rgba(255,255,255,.4),
          0 0 50px rgba(19,136,8,.35);

        transform:
          translate(-50%, -50%);

        animation:
          bieGlow
          1s
          ease-out
          forwards;

      }


      @keyframes bieGlow {

        0% {

          opacity: 0;

          transform:
            translate(-50%, -50%)
            scale(.3);

        }


        25% {

          opacity: 1;

        }


        100% {

          opacity: 0;

          transform:
            translate(-50%, -50%)
            scale(3);

        }

      }


      /* MOBILE */

      @media (max-width: 749px) {

        .bie-particle {

          width: 6px;
          height: 12px;

        }

      }

    `;

    document.head.appendChild(style);


    /* ==============================
       COLOURS
    ============================== */

    var colours = [
      '#FF9933',
      '#FFFFFF',
      '#138808'
    ];


    /* ==============================
       CENTRAL FLASH
    ============================== */

    var flash =
      document.createElement('div');

    flash.className =
      'bie-flash';

    container.appendChild(flash);


    /* ==============================
       CENTRAL GLOW
    ============================== */

    var glow =
      document.createElement('div');

    glow.className =
      'bie-glow';

    container.appendChild(glow);


    /* ==============================
       CREATE MAIN BURST
    ============================== */

    for (var i = 0; i < 80; i++) {

      var particle =
        document.createElement('span');

      particle.className =
        'bie-particle';


      /*
        Start from centre
      */

      particle.style.left =
        '50%';

      particle.style.top =
        '42%';


      /*
        Spread in all directions
      */

      var angle =
        (Math.PI * 2 * i / 80) +
        (Math.random() * 0.45);


      /*
        Slightly larger spread
      */

      var distance =
        170 +
        Math.random() * 270;


      var x =
        Math.cos(angle) *
        distance;


      var y =
        Math.sin(angle) *
        distance;


      particle.style.setProperty(
        '--x',
        x + 'px'
      );


      particle.style.setProperty(
        '--y',
        y + 'px'
      );


      /*
        Rotation
      */

      particle.style.setProperty(
        '--rotation',
        (Math.random() * 720 - 360) +
        'deg'
      );


      /*
        Random particle size
      */

      var width =
        6 +
        Math.random() * 4;


      var height =
        12 +
        Math.random() * 8;


      particle.style.width =
        width + 'px';


      particle.style.height =
        height + 'px';


      /*
        Tricolour
      */

      particle.style.background =
        colours[
          Math.floor(
            Math.random() *
            colours.length
          )
        ];


      /*
        Slight glow
      */

      particle.style.boxShadow =
        '0 0 7px rgba(255,255,255,.3)';


      /*
        Natural timing
      */

      particle.style.animationDelay =
        Math.random() *
        0.4 +
        's';


      container.appendChild(
        particle
      );

    }


    /* ==============================
       SECOND SMALLER BURST
    ============================== */

    setTimeout(function () {

      for (var i = 0; i < 40; i++) {

        var particle =
          document.createElement('span');

        particle.className =
          'bie-particle';


        particle.style.left =
          '50%';

        particle.style.top =
          '42%';


        var angle =
          Math.random() *
          Math.PI *
          2;


        var distance =
          120 +
          Math.random() * 180;


        particle.style.setProperty(
          '--x',
          Math.cos(angle) *
          distance +
          'px'
        );


        particle.style.setProperty(
          '--y',
          Math.sin(angle) *
          distance +
          'px'
        );


        particle.style.setProperty(
          '--rotation',
          (Math.random() * 720 - 360) +
          'deg'
        );


        particle.style.background =
          colours[
            Math.floor(
              Math.random() *
              colours.length
            )
          ];


        particle.style.animationDelay =
          Math.random() *
          0.25 +
          's';


        container.appendChild(
          particle
        );

      }

    }, 350);


    /* ==============================
       REMOVE EFFECT
    ============================== */

    setTimeout(function () {

      if (container.parentNode) {

        container.parentNode.removeChild(
          container
        );

      }


      if (style.parentNode) {

        style.parentNode.removeChild(
          style
        );

      }

    }, 5500);

  }


  /* ==============================
     START AFTER PAGE LOAD
  ============================== */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        setTimeout(
          launchIndependenceBurst,
          700
        );

      }
    );

  } else {

    setTimeout(
      launchIndependenceBurst,
      700
    );

  }

})();